import React from 'react'
import {connect} from 'react-redux'

import CheckoutSuccess from '../components/CheckoutSuccess'
import CreateAccount from './CreateAccount'

function Checkout(props) {
    return(
        <div className="container CreateAccount">
            <div className="Account">
                {
                    props.isAuthenticated
                    ?
                    <CheckoutSuccess />
                    :
                    <CreateAccount />
                }                
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAuthenticated
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
    }
}
  
  
export default connect(mapStateToProps, mapDispatchToProps)(Checkout);




// WEBPACK FOOTER //
// ./src/containers/Checkout.jsx